import React, { useEffect, useState } from "react";
import axios from "../axiosInstance";
import { useNavigate } from "react-router-dom";
import VideoCard from "../components/VideoCard";

function FriendsPage() {
  // ===============================
  // STATE
  // ===============================
  const [videos, setVideos] = useState([]);
  const [error, setError] = useState(null);
  const navigate = useNavigate();

  // ===============================
  // UTILISATEUR CONNECTÉ
  // ===============================
  const currentUser = JSON.parse(localStorage.getItem("currentUser"));
  const userEmail = currentUser?.email || currentUser?.user?.email;

  // ===============================
  // CHARGEMENT DU FEED AMIS
  // ===============================
  useEffect(() => {
    if (!userEmail) {
      setError("Utilisateur non connecté");
      return;
    }

    const fetchFriendsFeed = async () => {
      try {
        const res = await axios.get(
          `/videos/friends-feed?email=${encodeURIComponent(userEmail)}`
        );

        setVideos(Array.isArray(res.data) ? res.data : []);
        setError(null);
      } catch (err) {
        console.error("❌ Erreur feed amis :", err);
        setError("Impossible de charger le feed amis");
      }
    };

    fetchFriendsFeed();
  }, [userEmail]);

  // ===============================
  // RENDER
  // ===============================
  return (
    <div style={{ backgroundColor: "#000", color: "cyan", padding: "20px" }}>
      <h2>👥 Feed Amis</h2>

      {error && <p style={{ color: "red" }}>❌ {error}</p>}

      {!error && videos.length === 0 && (
        <p style={{ color: "gray" }}>Aucun contenu</p>
      )}

      {videos.map((video) => (
        <div
          key={video.id}
          style={{
            backgroundColor: "#111",
            marginBottom: "30px",
            padding: "15px",
            borderRadius: "10px",
            maxWidth: "450px",
            marginLeft: "auto",
            marginRight: "auto",
            position: "relative",
          }}
        >
          {/* 👤 PROFIL */}
          <div
            style={{
              display: "flex",
              alignItems: "center",
              marginBottom: "10px",
            }}
          >
            <img
              src={
                video.profile_picture
                  ? video.profile_picture.startsWith("http")
                    ? video.profile_picture
                    : `/uploads/${video.profile_picture.replace(/^\/+/, "")}`
                  : "/uploads/profile_pics/default.png"
              }
              alt={video.pseudo || "Utilisateur"}
              style={{
                width: "40px",
                height: "40px",
                borderRadius: "50%",
                marginRight: "10px",
                cursor: "pointer",
                objectFit: "cover",
              }}
              onClick={() => navigate(`/user/${video.pseudo}`)}
            />

            <div>
              <strong
                style={{ color: "cyan", cursor: "pointer" }}
                onClick={() => navigate(`/user/${video.pseudo}`)}
              >
                @{video.pseudo || "inconnu"}
              </strong>
              <br />
              <button
                style={{
                  marginTop: "5px",
                  padding: "4px 8px",
                  fontSize: "0.8em",
                  backgroundColor: "#444",
                  color: "white",
                  border: "none",
                  borderRadius: "5px",
                  cursor: "pointer",
                }}
                onClick={() => navigate(`/user/${video.pseudo}`)}
              >
                Profil
              </button>
            </div>
          </div>

          {/* 🎬 VIDÉO */}
          <VideoCard
            video={{
              ...video,
              user_pseudo: video.pseudo || video.user_pseudo,
            }}
            currentUserEmail={userEmail}
          />

          {/* TITRE */}
          <p style={{ marginTop: "10px", color: "cyan" }}>
            {video.title || video.description || "Sans titre"}
          </p>
        </div>
      ))}
    </div>
  );
}

export default FriendsPage;
